import React, { useState } from "react";
import Tabs from "../../../Component/DigitalMarketing/Tabs";
import { useGetAppointmentSummaryQuery } from "../../../Service/dashboard";
import MonthFilterSelect from "../../../Component/DigitalMarketing/MonthFilter";

const AppointementsSummary = () => {
  const [selectedMonth, setSelectedMonth] = useState("this Month");

  const monthOptions = [
    { value: "this Month", label: "This Month" },
    { value: "previous Month", label: "Previous Month" },
  ];

  const { data:appointmentData, refetch, isLoading } = useGetAppointmentSummaryQuery(selectedMonth, {
    refetchOnMountOrArgChange: true,
  });

  const data = [
    {
      id: "1",
      label: "Total Appointments",
      count: `${appointmentData?.data[0]?.totalConsultants}`,
      bgcolor: true,
    },
    {
      id: "2",
      label: "In Person",
      count: `${appointmentData?.data[0]?.inPersonCount}`,
    },
    {
      id: "3",
      label: "Virtual",
      count: `${appointmentData?.data[0]?.virtualCount}`,
    },
  ];
  return (
    <div>
       <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Appointments</span>
        </div>
        <div>
          <MonthFilterSelect
            value={selectedMonth}
            onChange={setSelectedMonth}
            options={monthOptions}
          />
        </div>
      </div>
      <div className="row gap-2">
        {data?.map((d: any) => (
          <div
            className="cards  mt-3"
            key={d?.id}
            style={{ backgroundColor: d?.bgcolor ? "#EFF8FF" : "#fff",width:"223px" }}
          >
            <div>
              <span className="f-16 fw-400">{d?.label}</span>
            </div>
            <div>
              <span className="f-32 fw-600">{d?.count}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppointementsSummary;
